import * as React from "react";
import DiscussionContext from "./Context";
import "./SortComponent.styl";

export default class SortComponent extends React.Component<{
    current: string;
}> {

    public render(): React.ReactNode {
        return (
            <DiscussionContext.Consumer>
                {({dispatch, translate, fullwidth}) => (
                    <div className="Discussion-Sort-Root" data-fullwidth={fullwidth ? "1" : "0"}>
                        <div className="Discussion-Sort-Button" onClick={() => {
                            dispatch("sort", "rating");
                        }} data-active={this.props.current == "rating" ? "1" : "0"}>
                            {translate("SORT_RATING")}
                        </div>
                        <div className="Discussion-Sort-Button" onClick={() => {
                            dispatch("sort", "timestamp");
                        }} data-active={this.props.current == "timestamp" ? "1" : "0"}>
                            {translate("SORT_TIMESTAMP")}
                        </div>
                    </div>
                )}
            </DiscussionContext.Consumer>
        );
    }

}